<template>
    <cadastro-simples-list
        endpoint="religiao"
        rota-base="/admin/religiao"
        titulo="RELIGIÕES"
        titulo-singular="Religião"
        :colunas-extras='[]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
